import {RestService} from "./RestService";

export class LocationService extends RestService {
	constructor() {
		super("api/v1/locations");
	}
}